import React, { ReactElement } from 'react'
import { OnChangeDateCallback } from 'react-calendar'
import { format } from 'date-fns'
import { dateFormats } from '@mindfulchefuk/lib/dateFormats'
import {
  Box,
  Calendar,
  calendarStyles,
  Dropdown,
  Flex,
  Icon,
  ResetButton,
  Text,
} from '@mindfulchefuk/design-system'
import { onboardingCalendarStyles } from '@mindfulchefuk/features/Onboarding/components/Calendar/onboardingCalendar.styles'

export type TOnboardingChooseRecipesCalendarFilter = {
  date: Date
  isOpen: boolean
  onToggle: () => void
  onChange: OnChangeDateCallback
  firstAvailableDeliveryDate: Date
  lastAvailableDeliveryDate: Date
  unavailableDates: string[]
}

export const OnboardingChooseRecipesCalendarFilter = ({
  date,
  isOpen,
  onToggle,
  onChange,
  firstAvailableDeliveryDate,
  lastAvailableDeliveryDate,
  unavailableDates,
}: TOnboardingChooseRecipesCalendarFilter): ReactElement => {
  const tileDisabled = ({ date: calendarDate }: { date: Date }) => {
    return unavailableDates.includes(dateFormats.iso(calendarDate))
  }
  return (
    <Box position="relative" id="calendar-filter">
      <ResetButton
        display="block"
        data-testid="recipe-filter-calendar"
        onClick={() => {
          onToggle()
        }}
      >
        <Flex color="aubergine">
          <Icon type="calendar" flexShrink={0} mr={8} />
          <Text
            variant="body-sm-500-caps"
            as="span"
            color="aubergine"
            data-testid="calendar-label"
          >
            {format(date, 'dddd D MMM')}
          </Text>
          <Icon ml={10} type={isOpen ? 'chevron-up' : 'chevron-down'} />
        </Flex>
      </ResetButton>
      <Dropdown
        data-testid="recipe-dropdown-calendar"
        isOpen={isOpen}
        onToggle={onToggle}
        alignment={['left', 'right', 'left']}
        maxWidth="316px"
        width={{ sm: '316px' }}
        py={0}
        px={0}
      >
        <Calendar
          serializedStyles={[calendarStyles, onboardingCalendarStyles]}
          value={date}
          minDate={firstAvailableDeliveryDate}
          maxDate={lastAvailableDeliveryDate}
          tileDisabled={tileDisabled}
          onChange={onChange}
        />
      </Dropdown>
    </Box>
  )
}
